module.exports = __webpack_public_path__ + "static/media/abhishek.1ab16d88.jpeg";